export enum Permissions {
  USE_SETTINGS = "use_settings",
}
